let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("axxbu")).then(() => parcelRequire('2nJpt'));